<template>
  <div>
    <SearchPage/>
  </div>
</template>

<script>
import SearchPage from "./components/SearchPage.vue"
export default {
  name: 'App',
  components: {
    SearchPage,
  },
  data() {
    return {}
  },
}
</script>

<style>
</style>
